// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"88cd65a069e34e71","562":"f888e04de5cb6c8c","931":"c94062a7ca38289d"}[chunkId] + ".css";
};